var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"btn btn-success",attrs:{"id":"submit-work"},on:{"click":_vm.handleClick}},[_vm._v("\n        "+_vm._s(_vm.ctaText)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }